<template>
  <v-container>
    <v-row style="margin:0;">
      <h3
        id="head"
        class="hideOverflow"
        data-aos="fade-up"
        data-aos-duration="1000"
        style="margin:40px 0 40px 0; padding-left:40px;"
      >
        Projects
      </h3>
    </v-row>
    <v-row style="margin:0;">
      <v-card
        dark
        color="#252734"
        width="500"
        height="600"
        class="hideOverflow"
        data-aos="fade-up"
        data-aos-duration="1000"
        shaped
        elevation="20"
        style="overflow:hidden; margin: 40px 30px 40px 30px;"
      >
        <v-card-title>
          VEnEx <v-spacer />
          <v-btn
            icon
            href="https://github.com/kingavatar/venex"
            target="_blank"
          >
            <v-icon>mdi-github</v-icon>
          </v-btn>
          <v-btn
            icon
            href="https://kingavatar.github.io/venex/"
            target="_blank"
          >
            <v-icon>mdi-web</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle>Primary Full Stack Developer</v-card-subtitle>
        <v-card-text class="card_text"
          >This is a software application developed for the finals of the Smart
          India Hackathon 2020 for MIXORG.It uses Object Based Detection to
          recognize license plates and send the activity to the Vue Application.
        </v-card-text>
        <v-img src="../assets/venex.png"> </v-img>
      </v-card>
    </v-row>
    <v-row style="margin:0;">
      <v-card
        dark
        color="#252734"
        width="500"
        height="600"
        class="hideOverflow"
        data-aos="fade-up"
        data-aos-duration="1000"
        shaped
        elevation="20"
        style="overflow:hidden; margin: 40px 30px 40px 30px;"
      >
        <v-card-title
          >Airline Management System<v-spacer />
          <v-btn
            icon
            href="https://github.com/kingavatar/Airline-Management-System"
            target="_blank"
          >
            <v-icon>mdi-github</v-icon>
          </v-btn></v-card-title
        >
        <v-card-subtitle>Primary Full Stack Developer</v-card-subtitle>
        <v-card-text class="card_text"
          >This is a Hibernate Java Database Application which handles
          transactions between management and customers of airline through the
          SWT GUI and mysql database.</v-card-text
        >
        <v-img src="../assets/airline.png"> </v-img>
      </v-card>
    </v-row>
    <v-row style="margin:0;">
      <v-card
        dark
        color="#252734"
        width="500"
        height="600"
        class="hideOverflow"
        data-aos="fade-up"
        data-aos-duration="1000"
        shaped
        elevation="20"
        style="overflow:hidden; margin: 40px 30px 40px 30px;"
      >
        <v-card-title
          >Mosip Qr Face Autentication Application<v-spacer />
          <v-btn
            icon
            href="https://github.com/kingavatar/Mosip_Android"
            target="_blank"
          >
            <v-icon>mdi-github</v-icon>
          </v-btn></v-card-title
        >
        <v-card-subtitle>Primary Android Developer</v-card-subtitle>
        <v-card-text class="card_text"
          >This is an Native Android Application developed for Mosip. We
          developed a Face Recognition based QRCode Autentication System. This
          Project involoved Image Compression for storing QRcode and using the
          Dlib Library for recognising faces stored in the QRCode. My
          Contribution for this project was the UI development and integration
          of Dlib Face Recognition Library and the QRcode decoder.
        </v-card-text>
        <v-img src="../assets/mosip.png"> </v-img>
      </v-card>
    </v-row>
    <v-row style="margin:0;">
      <v-card
        dark
        color="#252734"
        width="500"
        height="600"
        class="hideOverflow"
        data-aos="fade-up"
        data-aos-duration="1000"
        shaped
        elevation="20"
        style="overflow:hidden; margin: 40px 30px 40px 30px;"
      >
        <v-card-title
          >Mess Menu Application<v-spacer />
          <v-btn
            icon
            href="https://github.com/kingavatar/Mess-Menu-Application"
            target="_blank"
          >
            <v-icon>mdi-github</v-icon>
          </v-btn></v-card-title
        >
        <v-card-subtitle>Primary Android Developer</v-card-subtitle>
        <v-card-text class="card_text"
          >This is a Native Android Application developed as part of my personal
          projects for easier viewing of the campus Mess Menu Excel sheets with
          Ratings and Feedback.</v-card-text
        >
        <v-img src="../assets/menu.png"> </v-img>
      </v-card>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "ProjectsMobile"
};
</script>
<style scoped>
.container {
  margin-left: 64px;
  padding-right: 64px;
  margin-right: 0px;
  max-width: 100%;
}
#head {
  color: #999aa2;

  font-family: "Gilroy Regular";
  font-size: 2.5rem;
}
.card_text {
  font-family: "Gilroy Medium";
  font-size: 1.25rem;
}
.v-card__title {
  font-family: "Gilroy Bold";
}
.v-card__subtitle {
  font-family: "Gilroy SemiBold";
}
</style>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
@media #{map-get(
    $display-breakpoints,
    "sm-and-down"
  )} {
  .hideOverflow {
    overflow-x: hidden;
  }
  .container {
    margin-left: 0px;
    padding-right: 0px;
    margin-right: 0px;
    max-width: 100%;
  }
}
@font-face {
  font-family: "Gilroy Bold";
  src: url("../assets/fonts/Gilroy-Bold.eot");
  src: url("../assets/fonts/Gilroy-Bold.eot?#iefix") format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Bold.woff") format("woff"),
    url("../assets/fonts/Gilroy-Bold.otf") format("opentype"),
    url("../assets/fonts/Gilroy-Bold.ttf") format("truetype"),
    url("../assets/fonts/Gilroy-Bold.svg") format("svg");
}
@font-face {
  font-family: "Gilroy SemiBold";
  src: url("../assets/fonts/Gilroy-SemiBold.eot");
  src: url("../assets/fonts/Gilroy-SemiBold.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-SemiBold.woff") format("woff"),
    url("../assets/fonts/Gilroy-SemiBold.otf") format("opentype");
}
@font-face {
  font-family: "Gilroy Medium";
  src: url("../assets/fonts/Gilroy-Medium.eot");
  src: url("../assets/fonts/Gilroy-Medium.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Medium.woff") format("woff"),
    url("../assets/fonts/Gilroy-Medium.otf") format("opentype");
}
@font-face {
  font-family: "Gilroy Regular";
  src: url("../assets/fonts/Gilroy-Regular.eot");
  src: url("../assets/fonts/Gilroy-Regular.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/Gilroy-Regular.woff") format("woff"),
    url("../assets/fonts/Gilroy-Regular.otf") format("opentype");
}
</style>
